import { useState } from "react";
import useDebounce from "@hooks/useDebounce";

// Typing waits this long before a routing list filters again.
export const ROUTING_SEARCH_DEBOUNCE_MS = 300;

/**
 * Search box state for a routing screen: `text` follows the input, `query`
 * is the debounced value the list filters on. Starts empty on every visit.
 */
export function useRoutingSearch(delay = ROUTING_SEARCH_DEBOUNCE_MS) {
  const [text, setText] = useState("");
  const query = useDebounce(text, delay);
  return { text, setText, query };
}
